// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1wytF","content":"LayoutSettings_content__1wQdv"};